export const Regex = {
  phone: /^(^$|([+][4][2][0])?( ?(\d{3}) ?){3}?)$/,
  email: /.[a-zA-Z]{2,}$/,
  zipCode: /^(\d{3}) ?(\d{2})$/,
  password: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/,
};
